document.addEventListener('DOMContentLoaded', function () {
  var modal = document.getElementById('policy-modal');
  var modalTitle = document.getElementById('policy-modal-title');
  var modalClose = document.getElementById('policy-modal-close');
  var modalLoading = document.getElementById('policy-modal-loading');
  var modalContent = document.getElementById('policy-modal-content');
  var modalBody = modal ? modal.querySelector('.policy-modal__body') : null;
  var currentModalPageUrl = '';

  if (!modal || !modalTitle || !modalLoading || !modalContent || !modalBody) {
    return;
  }

  function openModal(title) {
    modal.hidden = false;
    modalTitle.textContent = title || '内容確認';
    modalLoading.style.display = 'block';
    modalContent.innerHTML = '';
    modalContent.classList.remove('is-visible');
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('policy-modal-open');
    modalBody.scrollTop = 0;
  }

  function closeModal() {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    modal.hidden = true;
    document.body.classList.remove('policy-modal-open');
    modalLoading.style.display = 'block';
    modalContent.innerHTML = '';
    modalContent.classList.remove('is-visible');
    modalBody.scrollTop = 0;
    currentModalPageUrl = '';
  }

  function absolutizeLinks(root, baseUrl) {
    root.querySelectorAll('a[href], img[src]').forEach(function (el) {
      if (el.hasAttribute('href')) {
        var rawHref = el.getAttribute('href') || '';

        try {
          if (rawHref.charAt(0) === '#') {
            el.setAttribute('data-modal-anchor', rawHref);
          } else {
            var absHref = new URL(rawHref, baseUrl).toString();
            el.setAttribute('href', absHref);

            var base = new URL(baseUrl, window.location.origin);
            var target = new URL(absHref, window.location.origin);

            if (
              target.origin === base.origin &&
              target.pathname === base.pathname &&
              target.hash
            ) {
              el.setAttribute('data-modal-anchor', target.hash);
            } else if (/^https?:/i.test(absHref)) {
              el.setAttribute('target', '_blank');
              el.setAttribute('rel', 'noopener noreferrer');
            }
          }
        } catch (e) {}
      }

      if (el.hasAttribute('src')) {
        try {
          el.setAttribute('src', new URL(el.getAttribute('src'), baseUrl).toString());
        } catch (e) {}
      }
    });
  }

  function cleanContent(root) {
    root.querySelectorAll('script, style, noscript, iframe').forEach(function (node) {
      node.remove();
    });
  }

  function extractPolicyContent(doc) {
    var selectors = [
      'main .shopify-policy__container',
      'main .page-width .rte',
      'main .rte',
      '.shopify-policy__container',
      '.main-page-content',
      '.page-width .rte',
      'article .rte',
      'main'
    ];

    for (var i = 0; i < selectors.length; i++) {
      var node = doc.querySelector(selectors[i]);
      if (node && node.innerHTML && node.innerHTML.trim()) {
        return node.cloneNode(true);
      }
    }

    return null;
  }

  async function loadPageIntoModal(url, title) {
    openModal(title);

    try {
      var response = await fetch(url, {
        method: 'GET',
        credentials: 'same-origin',
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      });

      if (!response.ok) {
        throw new Error('page fetch failed');
      }

      var html = await response.text();
      var parser = new DOMParser();
      var doc = parser.parseFromString(html, 'text/html');
      var contentNode = extractPolicyContent(doc);

      if (!contentNode) {
        throw new Error('content not found');
      }

      currentModalPageUrl = response.url || url;

      absolutizeLinks(contentNode, currentModalPageUrl);
      cleanContent(contentNode);

      modalLoading.style.display = 'none';
      modalContent.innerHTML =
        '<div class="policy-modal__prose">' + contentNode.innerHTML + '</div>';
      modalContent.classList.add('is-visible');
      modalBody.scrollTop = 0;
    } catch (error) {
      modalLoading.style.display = 'none';
      modalContent.innerHTML =
        '<div class="policy-modal__prose"><p>ページ内容を読み込めませんでした。</p></div>';
      modalContent.classList.add('is-visible');
      modalBody.scrollTop = 0;
    }
  }

  function findAnchorTarget(anchor) {
    if (!anchor) return null;

    var id = anchor.replace(/^#/, '');
    if (!id) return null;

    var escapedId = id;
    if (window.CSS && typeof window.CSS.escape === 'function') {
      escapedId = window.CSS.escape(id);
    } else {
      escapedId = id.replace(/([ !"#$%&'()*+,./:;<=>?@[\\\]^`{|}~])/g, '\\$1');
    }

    return (
      modalContent.querySelector('#' + escapedId) ||
      modalContent.querySelector('[name="' + id.replace(/"/g, '\\"') + '"]')
    );
  }

  function scrollModalToTarget(target) {
    if (!target || !modalBody) return;

    var bodyRect = modalBody.getBoundingClientRect();
    var targetRect = target.getBoundingClientRect();
    var nextTop = modalBody.scrollTop + (targetRect.top - bodyRect.top) - 12;

    modalBody.scrollTo({
      top: nextTop,
      behavior: 'smooth'
    });
  }

  document.addEventListener(
    'click',
    function (e) {
      var link = e.target.closest('.js-policy-link');
      if (!link) return;

      e.preventDefault();
      e.stopPropagation();
      if (typeof e.stopImmediatePropagation === 'function') {
        e.stopImmediatePropagation();
      }

      var url = link.getAttribute('href');
      var title = link.getAttribute('data-modal-title') || link.textContent.trim();
      loadPageIntoModal(url, title);
    },
    true
  );

  document.addEventListener('policy-consent:open-policy-modal', function (e) {
    var detail = e.detail || {};
    var type = detail.type || '';

    var map = {
      terms: {
        url: '/pages/%E5%88%A9%E7%94%A8%E8%A6%8F%E7%B4%84',
        title: '利用規約'
      },
      privacy: {
        url: '/pages/%E5%80%8B%E4%BA%BA%E6%83%85%E5%A0%B1%E4%BF%9D%E8%AD%B7%E6%96%B9%E9%87%9D',
        title: 'プライバシーポリシー'
      },
      thirdparty: {
        url: '/pages/foreign-transfer',
        title: '第三者提供に関する参考となる情報'
      }
    };

    var entry = map[type];
    if (!entry) return;

    loadPageIntoModal(entry.url, entry.title);
  });

  modalContent.addEventListener('click', function (e) {
    var link = e.target.closest('a[href], a[data-modal-anchor]');
    if (!link) return;

    var anchor =
      link.getAttribute('data-modal-anchor') ||
      link.getAttribute('href') ||
      '';

    if (!anchor) return;

    var hash = '';

    if (anchor.charAt(0) === '#') {
      hash = anchor;
    } else {
      try {
        var linkUrl = new URL(anchor, currentModalPageUrl || window.location.href);
        var baseUrl = new URL(
          currentModalPageUrl || window.location.href,
          window.location.origin
        );

        if (
          linkUrl.origin === baseUrl.origin &&
          linkUrl.pathname === baseUrl.pathname &&
          linkUrl.hash
        ) {
          hash = linkUrl.hash;
        }
      } catch (err) {}
    }

    if (!hash) return;

    e.preventDefault();

    var target = findAnchorTarget(hash);
    if (target) {
      scrollModalToTarget(target);
    } else {
      link.removeAttribute('href');
    }
  });

  if (modalClose) {
    modalClose.addEventListener('click', closeModal);
  }

  modal.addEventListener('click', function (e) {
    if (e.target && e.target.getAttribute('data-close') === 'true') {
      closeModal();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal.classList.contains('is-open')) {
      closeModal();
    }
  });
});